export const deviceSizes = {
  xs: '479px',
  sm: '767px',
  md: '1023px',
  lg: '1439px',
  xl: '1919px',
}
